import { Organization } from "common/Database";
import { styled } from "sharedUI/styles";
import TeamInviteModal from "designer/modals-v2/team-invite/team-invite-modal";
import * as React from "react";
import AppIcon from "common/app-icon";

interface Props {
    readonly organization: Organization;
    readonly userID: string;
    readonly source: string;
}

const ButtonStyle = styled.div`
    &:hover {
        background: ${p => p.theme.n300A};
        transition: ${p => p.theme.transitionBase};
    }

    display: flex;
    justify-content: center;
    align-items: center;
    width: max-content;
    color: ${p => p.theme.iconDark};
    background: ${p => p.theme.n200A};
    font-weight: 600;
    font-size: 13px;
    border-radius: 8px;
    padding: 6px 12px;
    cursor: pointer;
    box-shadow: ${p => p.theme.shadow0};

    svg {
        margin-right: 4px;
    }

    > span {
        flex-grow: 1;
    }
`;

const InviteMemberButtonImpl: React.FC<Props> = p => {
    const { organization, userID, source } = p;

    const [showShareModal, setShowShareModal] = React.useState(false);

    const onButtonClick = React.useCallback(() => {
        setShowShareModal(true);
    }, []);

    const onClose = React.useCallback(() => {
        setShowShareModal(false);
    }, []);

    const modal = <TeamInviteModal source={source} organization={organization} userID={userID} onClose={onClose} />;

    return (
        <>
            {showShareModal && modal}
            <ButtonStyle className={`invite-member-button`} onClick={onButtonClick}>
                <AppIcon icon={"plusStroke"} size={16} />
                <span>Invite Members</span>
            </ButtonStyle>
        </>
    );
};

export const InviteMemberButton = InviteMemberButtonImpl;
